// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import {
//   Container,
//   Box,
//   Typography,
//   TextField,
//   Switch,
//   FormControlLabel,
//   Button,
//   CircularProgress,
//   Paper,
//   Alert,
//   Chip,
//   Breadcrumbs,
//   Link as MuiLink,
// } from '@mui/material';
// import { Link, useParams, useNavigate } from 'react-router-dom';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import UpdateIcon from '@mui/icons-material/Update';
// import LinkIcon from '@mui/icons-material/Link';
// import CampaignIcon from '@mui/icons-material/Campaign';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import { GetOnecampaignData, UpdateOneCampaignData } from '../../Redux/Actions/Campaign_Actions';
// import { useDispatch, useSelector } from 'react-redux';
// import { Notify } from '../../Utility/Notify';
// import { useTheme } from '@mui/material/styles';

// export const UpdateCamgaign = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { id } = useParams();

//   // States
//   const [userlogin, setUserlogin] = useState('');
//   const [updateCampaignLoading, setUpdateCampaignLoading] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [formErrors, setFormErrors] = useState({});
//   const [originalData, setOriginalData] = useState(null);

//   // Form states
//   const [campaignName, setCampaignName] = useState('');
//   const [cost, setCost] = useState('');
//   const [redirectLink, setRedirectLink] = useState('');
//   const [isActive, setIsActive] = useState(true);
//   const [value, setValue] = useState(null);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setUserlogin(user);
//     }
//   }, []);

//   const handleDateChange = (newValue) => {
//     if (newValue) {
//       const formattedDate = newValue.format('YYYY-MM-DD');
//       setValue(formattedDate);
//     } else {
//       setValue(null);
//     }
//   };

//   const validateForm = () => {
//     const errors = {};

//     if (!campaignName.trim()) {
//       errors.campaignName = 'Please enter campaign name';
//     }

//     if (!cost || parseFloat(cost) < 0.0) {
//       errors.cost = 'Please enter valid cost';
//     }

//     // ✅ Redirect link is no longer required
//     if (redirectLink && !/^(https?:\/\/)/.test(redirectLink)) {
//       errors.redirectLink = 'Please enter a valid URL (start with http:// or https://)';
//     }

//     if (!value) {
//       errors.date = 'Please select date';
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const getOneCampaign = async () => {
//     // setLoading(true);
//     await dispatch(GetOnecampaignData(id));
//     // setLoading(false);
//   };

//   useEffect(() => {
//     getOneCampaign();
//   }, [id]);

//   const resGetOneData = useSelector((state) => state.AllCampaign.getcampaign);

//   useEffect(() => {
//     if (resGetOneData?.data) {
//       const data = resGetOneData.data;
//       setCampaignName(data.CampainName || '');
//       setCost(data.Cost || '');
//       setRedirectLink(data.redirectLink || '');
//       setValue(data.Date || null);
//       setIsActive(data.isactivate !== false);
//       setOriginalData(data);
//     }
//   }, [resGetOneData]);

//   const user = JSON.parse(localStorage.getItem('user')) || {};

//   const updateCampaignSubmit = async () => {
//     if (!validateForm()) {
//       Notify('error', 'Please fix form errors', 'error');
//       return;
//     }

//     setUpdateCampaignLoading(true);
//     setLoading(true);

//     const campaignData = {
//       CampainName: campaignName,
//       Date: value,
//       Cost: cost,
//       redirectLink: redirectLink,
//       isactivate: isActive,
//       updatedby: user.data?._id || user._id,
//     };

//     if (!isActive) {
//       campaignData.endDate = new Date().toISOString();
//     }

//     try {
//       await dispatch(UpdateOneCampaignData(id, campaignData));
//       Notify('success', 'Campaign updated successfully', 'success');

//       // Redirect after successful update
//       setTimeout(() => {
//         navigate('/Campaigns');
//       }, 1500);
//     } catch (error) {
//       Notify('error', 'Failed to update campaign', 'error');
//     } finally {
//       setUpdateCampaignLoading(false);
//       setLoading(false);
//     }
//   };

//   const resUpdateData = useSelector((state) => state.AllCampaign.updatecampaign);

//   useEffect(() => {
//     if (loading === false) {
//       if (resUpdateData?.status === 200) {
//         Notify('success', 'Campaign updated successfully', 'success');
//       }
//     }
//   }, [loading]);

//   // Breadcrumb routes
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeadsForAdmin'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer'
//         : '/';

//   const campaignsRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/Campaigns'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/Campaigns'
//         : '/';

//   if (loading && !originalData) {
//     return (
//       <Container maxWidth="lg" sx={{ mt: 4 }}>
//         <Box
//           sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}
//         >
//           <CircularProgress />
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }} style={{ marginTop: '95px' }}>
//       {/* Breadcrumb */}
//       <Breadcrumbs
//         separator={<NavigateNextIcon fontSize="small" />}
//         aria-label="breadcrumb"
//         sx={{ mb: 4 }}
//       >
//         <MuiLink
//           component={Link}
//           to={homeRoute}
//           underline="hover"
//           sx={{
//             color: '#1976d2',
//             fontWeight: 'bold',
//             display: 'flex',
//             alignItems: 'center',
//             gap: 0.5,
//           }}
//         >
//           Home
//         </MuiLink>

//         <MuiLink
//           component={Link}
//           to={campaignsRoute}
//           underline="hover"
//           sx={{
//             color: mode === 'dark' ? '#ccc' : '#666',
//             fontWeight: 'bold',
//           }}
//         >
//           Campaigns
//         </MuiLink>

//         <Typography
//           color="text.primary"
//           sx={{
//             color: mode === 'dark' ? '#fff' : '#333',
//             fontWeight: 'bold',
//           }}
//         >
//           Update Campaign
//         </Typography>
//       </Breadcrumbs>

//       {/* Header */}
//       <Paper
//         elevation={3}
//         sx={{
//           p: 4,
//           mb: 4,
//           borderRadius: 3,
//           background: mode === 'dark' ? 'linear-gradient(45deg, #1e1e1e 30%, #252525 90%)' : '#fff',
//           border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//         }}
//       >
//         <Box
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: 2,
//             mb: 3,
//           }}
//         >
//           <Box
//             sx={{
//               width: 60,
//               height: 60,
//               borderRadius: 3,
//               background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               boxShadow: 2,
//             }}
//           >
//             <UpdateIcon sx={{ fontSize: 32, color: 'white' }} />
//           </Box>

//           <Box>
//             <Typography
//               variant="h4"
//               sx={{
//                 fontWeight: 'bold',
//                 color: mode === 'dark' ? '#fff' : '#1976d2',
//                 mb: 0.5,
//               }}
//             >
//               Update Campaign
//             </Typography>
//             <Typography variant="body2" sx={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//               Campaign ID: {originalData?._id || id}
//             </Typography>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Form Section */}
//       <Paper
//         elevation={2}
//         sx={{
//           p: 4,
//           borderRadius: 3,
//           background: mode === 'dark' ? '#1e1e1e' : '#fff',
//           border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//         }}
//       >
//         <Typography
//           variant="h6"
//           sx={{
//             mb: 4,
//             fontWeight: 'bold',
//             color: mode === 'dark' ? '#fff' : '#333',
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1,
//           }}
//         >
//           <CampaignIcon /> Campaign Information
//         </Typography>

//         {/* Form Fields with consistent margins */}
//         <Box sx={{ '& > *:not(:last-child)': { mb: 3 } }}>
//           {/* Campaign Name */}
//           <TextField
//             fullWidth
//             label="Campaign Name"
//             variant="outlined"
//             value={campaignName}
//             onChange={(e) => {
//               setCampaignName(e.target.value);
//               if (formErrors.campaignName) setFormErrors({ ...formErrors, campaignName: '' });
//             }}
//             error={!!formErrors.campaignName}
//             helperText={formErrors.campaignName}
//             InputProps={{
//               startAdornment: <CampaignIcon sx={{ color: '#1976d2', mr: 1, opacity: 0.7 }} />,
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 '&:hover fieldset': {
//                   borderColor: '#1976d2',
//                 },
//               },
//             }}
//           />

//           {/* Date Picker */}
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               label="Start Date"
//               value={value ? dayjs(value) : null}
//               onChange={handleDateChange}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   variant: 'outlined',
//                   error: !!formErrors.date,
//                   helperText: formErrors.date || 'The date when the campaign starts',
//                   InputProps: {
//                     startAdornment: (
//                       <CalendarMonthIcon sx={{ color: '#1976d2', mr: 1, opacity: 0.7 }} />
//                     ),
//                   },
//                   sx: {
//                     '& .MuiOutlinedInput-root': {
//                       borderRadius: 2,
//                       '&:hover fieldset': {
//                         borderColor: '#1976d2',
//                       },
//                     },
//                   },
//                 },
//               }}
//             />
//           </LocalizationProvider>

//           {/* Cost */}
//           <TextField
//             fullWidth
//             type="number"
//             label="Cost ($)"
//             variant="outlined"
//             value={cost}
//             onChange={(e) => {
//               setCost(e.target.value);
//               if (formErrors.cost) setFormErrors({ ...formErrors, cost: '' });
//             }}
//             error={!!formErrors.cost}
//             helperText={formErrors.cost}
//             InputProps={{
//               startAdornment: <AttachMoneyIcon sx={{ color: '#1976d2', mr: 1, opacity: 0.7 }} />,
//               inputProps: { min: 0, step: '0.01' },
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: 2,
//                 '&:hover fieldset': {
//                   borderColor: '#1976d2',
//                 },
//               },
//             }}
//           />

//           {/* Redirect Link - No longer required */}
//           <Box>
//             <TextField
//               fullWidth
//               label="Redirect Link (Optional)"
//               variant="outlined"
//               value={redirectLink}
//               onChange={(e) => {
//                 setRedirectLink(e.target.value);
//                 if (formErrors.redirectLink) setFormErrors({ ...formErrors, redirectLink: '' });
//               }}
//               error={!!formErrors.redirectLink}
//               helperText={
//                 formErrors.redirectLink ||
//                 'Optional: The link users will be redirected to when clicking the campaign'
//               }
//               placeholder="https://example.com/campaign"
//               InputProps={{
//                 startAdornment: <LinkIcon sx={{ color: '#1976d2', mr: 1, opacity: 0.7 }} />,
//               }}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: 2,
//                   '&:hover fieldset': {
//                     borderColor: '#1976d2',
//                   },
//                 },
//               }}
//             />

//             {/* Link Preview - Only show if link exists and is valid */}
//             {redirectLink && !formErrors.redirectLink && (
//               <Alert
//                 severity="info"
//                 sx={{
//                   mt: 2,
//                   borderRadius: 2,
//                   backgroundColor: mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : '#e3f2fd',
//                   '& .MuiAlert-message': {
//                     fontSize: '0.875rem',
//                   },
//                 }}
//               >
//                 Link Preview:
//                 <MuiLink
//                   href={redirectLink}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   sx={{
//                     ml: 1,
//                     color: '#1976d2',
//                     textDecoration: 'none',
//                     fontWeight: '500',
//                     '&:hover': {
//                       textDecoration: 'underline',
//                     },
//                   }}
//                 >
//                   {redirectLink.length > 50 ? `${redirectLink.substring(0, 50)}...` : redirectLink}
//                 </MuiLink>
//               </Alert>
//             )}
//           </Box>

//           {/* Activation Switch */}
//           <Paper
//             elevation={0}
//             sx={{
//               p: 3,
//               mt: 2,
//               borderRadius: 2,
//               background: mode === 'dark' ? '#252525' : '#f5f5f5',
//               border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//             }}
//           >
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 flexWrap: 'wrap',
//                 gap: 2,
//               }}
//             >
//               <Box>
//                 <Typography
//                   variant="subtitle1"
//                   sx={{
//                     fontWeight: 'bold',
//                     color: mode === 'dark' ? '#fff' : '#333',
//                     mb: 0.5,
//                   }}
//                 >
//                   Campaign Status
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   {isActive
//                     ? 'Active - Campaign is live and accepting clicks'
//                     : 'Inactive - Campaign is paused'}
//                 </Typography>
//               </Box>

//               <FormControlLabel
//                 control={
//                   <Switch
//                     checked={isActive}
//                     onChange={(e) => setIsActive(e.target.checked)}
//                     color="primary"
//                     size="medium"
//                   />
//                 }
//                 label={
//                   <Chip
//                     label={isActive ? 'ACTIVE' : 'INACTIVE'}
//                     color={isActive ? 'success' : 'error'}
//                     sx={{ fontWeight: 'bold', minWidth: 80 }}
//                   />
//                 }
//                 sx={{ m: 0 }}
//               />
//             </Box>

//             {!isActive && originalData?.isactivate && (
//               <Alert
//                 severity="warning"
//                 sx={{
//                   mt: 2,
//                   borderRadius: 2,
//                   backgroundColor: mode === 'dark' ? 'rgba(255, 152, 0, 0.1)' : '#fff8e1',
//                 }}
//               >
//                 <Typography variant="body2">
//                   <strong>Note:</strong> Deactivating this campaign will set the end date to today.
//                 </Typography>
//               </Alert>
//             )}
//           </Paper>
//         </Box>

//         {/* Action Buttons */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mt: 4,
//             pt: 3,
//             borderTop: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//           }}
//         >
//           <Button
//             variant="outlined"
//             onClick={() => navigate('/Campaigns')}
//             sx={{
//               minWidth: '140px',
//               height: '48px',
//               borderRadius: 2,
//               borderColor: mode === 'dark' ? '#666' : '#ccc',
//               color: mode === 'dark' ? '#ccc' : '#666',
//               '&:hover': {
//                 borderColor: mode === 'dark' ? '#999' : '#999',
//                 backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
//               },
//             }}
//           >
//             Cancel
//           </Button>

//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <Button
//               variant="contained"
//               onClick={updateCampaignSubmit}
//               disabled={updateCampaignLoading}
//               startIcon={
//                 updateCampaignLoading ? (
//                   <CircularProgress size={20} color="inherit" />
//                 ) : (
//                   <UpdateIcon />
//                 )
//               }
//               sx={{
//                 minWidth: '200px',
//                 height: '48px',
//                 borderRadius: 2,
//                 background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
//                 color: 'white',
//                 fontWeight: 'bold',
//                 fontSize: '1rem',
//                 boxShadow: '0 3px 5px 2px rgba(33, 150, 243, .3)',
//                 '&:hover': {
//                   background: 'linear-gradient(45deg, #1565c0 30%, #1976d2 90%)',
//                   boxShadow: '0 4px 8px 2px rgba(33, 150, 243, .4)',
//                   transform: 'translateY(-2px)',
//                 },
//                 '&.Mui-disabled': {
//                   background: 'linear-gradient(45deg, #bbdefb 30%, #e3f2fd 90%)',
//                   color: '#666',
//                 },
//                 transition: 'all 0.3s ease',
//               }}
//             >
//               {updateCampaignLoading ? 'Updating...' : 'Update Campaign'}
//             </Button>
//           </Box>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };




































// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { GetOnecampaignData, UpdateOneCampaignData } from '../../Redux/Actions/Campaign_Actions';
import { Notify } from '../../Utility/Notify';
import EditIcon from '@mui/icons-material/Edit';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateCamgaign = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const { id }       = useParams();
  const sidebarWidth = useSidebarWidth();

  const [campaignName,  setCampaignName]  = useState('');
  const [cost,          setCost]          = useState('');
  const [redirectLink,  setRedirectLink]  = useState('');
  const [dateValue,     setDateValue]     = useState(null);
  const [isActive,      setIsActive]      = useState(true);
  const [originalData,  setOriginalData]  = useState(null);
  const [sending,       setSending]       = useState(false);
  const [loading,       setLoading]       = useState(true);
  const [formErrors,    setFormErrors]    = useState({});

  const user = JSON.parse(localStorage.getItem('user')) || {};

  /* ── fetch existing data ── */
  useEffect(() => {
    dispatch(GetOnecampaignData(id));
  }, [id]);

  const resGetOneData = useSelector((state) => state.AllCampaign.getcampaign);
  useEffect(() => {
    if (resGetOneData?.data) {
      const d = resGetOneData.data;
      setCampaignName(d.CampainName || '');
      setCost(d.Cost || '');
      setRedirectLink(d.redirectLink || '');
      setDateValue(d.Date || null);
      setIsActive(d.isactivate !== false);
      setOriginalData(d);
    }
  }, [resGetOneData]);

  /* ── validation ── */
  const validate = () => {
    const errors = {};
    if (!campaignName.trim()) errors.campaignName = 'Campaign name is required';
    if (!cost || parseFloat(cost) < 0) errors.cost = 'Valid cost is required';
    if (redirectLink.trim() && !/^(https?:\/\/)/.test(redirectLink))
      errors.redirectLink = 'URL must start with http:// or https://';
    if (!dateValue) errors.date = 'Date is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ── submit ── */
  const onsubmit = async () => {
    if (!validate()) return Notify('error', 'Please fix form errors', 'error');
    setSending(true);
    const campaignData = {
      CampainName: campaignName.trim(),
      Date: dateValue,
      Cost: cost,
      redirectLink: redirectLink.trim(),
      isactivate: isActive,
      updatedby: user.data?._id || user._id,
    };
    if (!isActive) campaignData.endDate = new Date().toISOString();
    try {
      await dispatch(UpdateOneCampaignData(id, campaignData));
      Notify('success', 'Campaign updated successfully', 'success');
      setTimeout(() => navigate('/Campaigns'), 1200);
    } catch {
      Notify('error', 'Failed to update campaign', 'error');
    } finally {
      setSending(false);
    }
  };

  /* ─── shared styles ─── */
  const inputStyle = (hasError) => ({
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  });
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const errorStyle = { fontSize: '12px', color: '#ef4444', margin: '5px 0 0' };
  const hintStyle  = { fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '5px 0 0' };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e, hasError) => {
    e.target.style.borderColor     = hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0');
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };
  const fieldWrap = { marginBottom: '20px' };

  /* ── loading state before data arrives ── */
  if (!originalData) {
    return (
      <div style={{
        position: 'fixed', top: '50px', left: sidebarWidth, right: 0, bottom: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      }}>
        <CircularProgress size={36} style={{ color: '#1d4ed8' }} />
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to="/Campaigns" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Campaigns
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Campaign</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
              Update Campaign
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Edit campaign details in the CRM system
            </p>
          </div>

          {/* ── Campaign Name ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Campaign Name *</label>
            <input
              style={inputStyle(!!formErrors.campaignName)}
              value={campaignName}
              onChange={(e) => { setCampaignName(e.target.value); if (formErrors.campaignName) setFormErrors(p => ({ ...p, campaignName: '' })); }}
              type="text"
              placeholder="e.g. Summer 2026 Campaign"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.campaignName)}
            />
            {formErrors.campaignName && <p style={errorStyle}>{formErrors.campaignName}</p>}
          </div>

          {/* ── Date ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Campaign Date *</label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dateValue ? dayjs(dateValue) : null}
                onChange={(v) => {
                  setDateValue(v ? v.format('YYYY-MM-DD') : null);
                  if (formErrors.date) setFormErrors(p => ({ ...p, date: '' }));
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: 'small',
                    error: !!formErrors.date,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        backgroundColor: isDark ? '#151827' : '#f8fafc',
                        fontSize: '14px',
                        fontFamily: "'DM Sans',sans-serif",
                        border: `1.5px solid ${formErrors.date ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
                        '& fieldset': { border: 'none' },
                        color: isDark ? '#f1f5f9' : '#0f172a',
                      },
                      '& .MuiInputBase-input': {
                        color: isDark ? '#f1f5f9' : '#0f172a',
                        padding: '13px 16px',
                      },
                      '& .MuiSvgIcon-root': { color: isDark ? '#9ca3af' : '#64748b' },
                    },
                  },
                }}
              />
            </LocalizationProvider>
            {formErrors.date && <p style={errorStyle}>{formErrors.date}</p>}
          </div>

          {/* ── Cost ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>Cost ($) *</label>
            <input
              style={inputStyle(!!formErrors.cost)}
              value={cost}
              onChange={(e) => { setCost(e.target.value); if (formErrors.cost) setFormErrors(p => ({ ...p, cost: '' })); }}
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.cost)}
            />
            {formErrors.cost && <p style={errorStyle}>{formErrors.cost}</p>}
          </div>

          {/* ── Redirect Link ── */}
          <div style={fieldWrap}>
            <label style={labelStyle}>
              Redirect Link{' '}
              <span style={{ fontSize: '10px', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span>
            </label>
            <input
              style={inputStyle(!!formErrors.redirectLink)}
              value={redirectLink}
              onChange={(e) => { setRedirectLink(e.target.value); if (formErrors.redirectLink) setFormErrors(p => ({ ...p, redirectLink: '' })); }}
              type="text"
              placeholder="https://example.com/campaign"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.redirectLink)}
            />
            {formErrors.redirectLink
              ? <p style={errorStyle}>{formErrors.redirectLink}</p>
              : <p style={hintStyle}>The link users will be redirected to when clicking the campaign</p>
            }
            {/* Link preview */}
            {redirectLink && !formErrors.redirectLink && /^(https?:\/\/)/.test(redirectLink) && (
              <div style={{
                marginTop: '8px', padding: '10px 14px', borderRadius: '8px',
                backgroundColor: isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.05)',
                border: `1px solid ${isDark ? 'rgba(37,99,235,0.2)' : 'rgba(37,99,235,0.15)'}`,
                fontSize: '12px', color: isDark ? '#93c5fd' : '#2563eb',
                display: 'flex', alignItems: 'center', gap: '6px',
              }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                <a href={redirectLink} target="_blank" rel="noopener noreferrer"
                  style={{ color: 'inherit', textDecoration: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {redirectLink.length > 60 ? redirectLink.slice(0, 60) + '…' : redirectLink}
                </a>
              </div>
            )}
          </div>

          {/* ── Status Toggle ── */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Campaign Status</label>
            <div style={{
              padding: '14px 16px', borderRadius: '10px',
              border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
              backgroundColor: isDark ? '#151827' : '#f8fafc',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div
                  onClick={() => setIsActive(p => !p)}
                  style={{
                    width: '44px', height: '24px', borderRadius: '12px', cursor: 'pointer',
                    backgroundColor: isActive ? '#1d4ed8' : (isDark ? '#374151' : '#d1d5db'),
                    transition: 'background-color 0.2s', position: 'relative', flexShrink: 0,
                  }}
                >
                  <div style={{
                    position: 'absolute', top: '3px',
                    left: isActive ? '23px' : '3px',
                    width: '18px', height: '18px', borderRadius: '50%',
                    backgroundColor: '#ffffff', transition: 'left 0.2s',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                  }} />
                </div>
                <span style={{ fontSize: '13px', fontWeight: 600, color: isActive ? (isDark ? '#4ade80' : '#16a34a') : (isDark ? '#f87171' : '#ef4444') }}>
                  {isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
              <span style={{ fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>
                {isActive ? 'Campaign is live and accepting clicks' : 'Campaign is paused'}
              </span>
            </div>
            {/* warning when deactivating a previously active campaign */}
            {!isActive && originalData?.isactivate && (
              <div style={{
                marginTop: '8px', padding: '10px 14px', borderRadius: '8px',
                backgroundColor: isDark ? 'rgba(251,191,36,0.08)' : 'rgba(251,191,36,0.08)',
                border: `1px solid ${isDark ? 'rgba(251,191,36,0.2)' : 'rgba(251,191,36,0.25)'}`,
                fontSize: '12px', color: isDark ? '#fbbf24' : '#92400e',
              }}>
                ⚠️ Deactivating this campaign will set the end date to today.
              </div>
            )}
          </div>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!sending ? onsubmit : null}
              disabled={sending}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { if (!sending) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              {sending
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><EditIcon sx={{ fontSize: 17 }} /><span>Update Campaign</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Campaigns')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8'; e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};
